import { Link } from 'react-router';
import { SpcState } from '../../../shared/types/spcState.ts';
import { encodeUrl } from '../../utils/encodeUrl.ts';


interface Props {
    spcStates: SpcState[]
}

export function SpcTable({
    spcStates,
}: Props) {
    return (
        <table>
            <thead>
                <tr>
                    <th>Equipment</th>
                    <th>Part number</th>
                    <th>Order number</th>
                    <th style={{ maxWidth: '80px' }}>Measurements<br />order / batch</th>
                    <th style={{ maxWidth: '70px' }}>Issues<br />enabled / all</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {spcStates.map(spcState => (
                    <tr key={spcState.equipment}>
                        <td className='textAlignLeft' style={{ paddingLeft: '60px' }}>
                            <Link className='link-button--non-intrusive' to={`/machine-log#equipment=${spcState.equipment}`}>
                                {spcState.equipmentDisplayName}
                            </Link>
                        </td>
                        <td className='textAlignLeft' style={{ paddingLeft: '60px' }}>
                            {spcState.partDisplayName}
                        </td>
                        <td>{spcState.orderNumber}</td>
                        <td>{spcState.measurementsInOrder} / {spcState.measurementsInBatch}</td>
                        <td>{spcState.enabledIssuesCount} / {spcState.allIssuesCount}</td>
                        <td>
                            {spcState.measurementsInBatch
                                ? <Link
                                    className='a__button'
                                    to={encodeUrl('/spc-details', { equipment: spcState.equipment, product: spcState.product })}
                                >
                                    View
                                </Link>
                                : <a className='a__button, a__button--disabled' href='#'>View</a>
                            }
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
